import { render, staticRenderFns } from "./Video-Gallery.vue?vue&type=template&id=be932fe6&"
import script from "./Video-Gallery.vue?vue&type=script&lang=js&"
export * from "./Video-Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Video-Gallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports